import { useQuery } from '@tanstack/react-query';
import { container } from '../../../../shared/di/container.js';
import { useAuthSession } from '../../../authentication/presentation/hooks/useAuth.js';

export function useOrgList(options?: { limit?: number; offset?: number }) {
  const { data: session } = useAuthSession();
  return useQuery({
    queryKey: ['orgs', session?.uid, options?.limit, options?.offset],
    queryFn: () => container.org.listOrgsUseCase(options),
    enabled: !!session?.uid,
  });
}
